var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":_vm.size + 'px',"viewBox":"0 0 107 107","fill":"none"}},[_c('path',{attrs:{"d":"M100 7L7 100","stroke":"#364B5D","stroke-width":"14","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M7 7L100 100","stroke":"#364B5D","stroke-width":"14","stroke-linecap":"round","stroke-linejoin":"round"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }